var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81 1.5a1.5 1.5 0 00-1.44 1.071l-2.824 9.483A1.125 1.125 0 005.625 13.5h2.374l-1.92 6.584c-.576 1.974 1.986 3.3 3.267 1.692l9.91-12.45a1.125 1.125 0 00-.881-1.826H15.33l1.49-3.974A1.5 1.5 0 0015.419 1.5H8.81z",
    fill: "#7210FF"
  })));
}

export default SvgFlash;